<template>
	<div class="link-static-table link-auto-table">
		<div class="link-auto-table-title" v-if="!!option.title">{{ option.title }}</div>
		<div class="link-auto-table-content">
			<lnk-quickfilter
				v-if="!!option.p_quickfilterOption"
				class="lnk-quickfilter"
				:options="option.p_quickfilterOption"
				:type="option.quickfilterType"
				:value="option.quickfilterValue"
				@change="option.pl_quickFilterChange"
			>
			</lnk-quickfilter>
			<div class="link-auto-table-header" v-if="!!option.showHeader">
				<div class="link-auto-table-header-left-side">
					<link-auto-table-filter
						v-if="option.showFilterBar"
						ref="singleFilter"
						@confirm="option.pl_singleFilterChange"
						:option="option"
						:filter-options="option.filterOptions"
						:search-field.sync="option.searchField"
						type="none"
						size="default"
						color="info"/>
				</div>
				<div class="link-auto-table-header-button-wrapper">
					<div>
						<slot name="button"></slot>
					</div>
				</div>
			</div>
			<div class="link-auto-table-body">
				<link-table
					ref="table"
					:data="option.pageData"
					:fixed-row-data="option.fixedRowData"
					:row-num="!option.noPaging?option.showNum:(option.pageData.length<3?3:option.pageData.length)"
					:sortField="option.sortField"
					:sortDesc="option.sortDesc"
					:rowHeight="option.bodyRowHeight"
					:defaultEnableEditable="option.defaultEnableEditable"
					:editSourceRow="option.defaultEnableEditable"
					:selectIndex="option.p_selectIndex"

					@collect="option.pl_collect"
					@sortChange="option.pl_sortChange"
					@rowClick="option.pl_rowClick"
					@rowDblClick="(e)=>$emit('rowDbClick', e)"
				>
					<link-table-column-index v-if="option.indexing" :page="option.page" :page-size="option.pageSize"/>
					<slot></slot>
				</link-table>
			</div>
			<div class="link-auto-table-footer" v-if="!option.noPaging">
				<link-pagebar
					:page="option.page"
					:pageSize="option.pageSize"
					:totalSize="option.listData.length"
					:sizeOption="option.sizeOption"
					:show-page-num="option.showPageNum"

					@sizeChange="e=>option.pageSize=e"
					@jumpPage="option.jumpPage"
					@prevPage="option.prevPage"
					@nextPage="option.nextPage"
				/>
				<div class="link-auto-table-footer-total-count-wrapper">
					当前显示<span v-if="option.listData.length>0">{{ (option.page - 1) * option.pageSize + 1 }}-{{ option.page * option.pageSize }}</span>，
					共 <span class="link-auto-table-footer-total-count-num">{{ option.listData.length }}</span> 条记录
				</div>
			</div>
			<link-loading-shadow :value="option.loading"/>
		</div>
	</div>
</template>

<script>
import LinkAutoTableFilter from "../auto-table/link-auto-table-filter";

export default {
	name: "link-static-table",
	components: {LinkAutoTableFilter},
	props: {
		option: {},
	},
	data() {
		return {}
	},
	mounted() {
		this.option.init(this)
	},
}
</script>

<style lang="scss">
@include themeify {
	$auto-table-inner-padding: 12px;
	.link-static-table {
		/*height: 100%;*/
		width: 100%;
		box-sizing: border-box;
		color: $auto-table-body-color;
		background-color: white;

		&:not(:last-child) {
			padding-bottom: 16px;
		}

		.link-auto-table-title {
			font-family: $font-family;
			font-size: 14px;
			line-height: 14px;
			font-weight: 500;
			color: #22252A;
			letter-spacing: 1px;
			padding-left: 8px;
			border-left: 3px solid $color-primary;
		}

		.link-auto-table-content {
			position: relative;
			box-sizing: border-box;

			.link-auto-table-shadow {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				z-index: 1;
				background-color: transparent;
				overflow: hidden;

				.link-auto-table-shadow-content {
					width: 100%;
					max-height: 100%;
					color: $color-primary;
					font-size: 13px;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
				}

			}

			.link-auto-table-header {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
			}

			.link-auto-table-footer {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}

		&.link-auto-table-fill {
			height: 100%;

			.link-auto-table-content {
				height: 100%;
				display: flex;
				flex-direction: column;

				.link-auto-table-body {
					flex: 1;
					overflow: hidden;

					.lv-base-table {
						height: 100%;
						display: flex;
						flex-direction: column;

						.lv-table-body {
							flex: 1;

							.lv-table-body-item {
								height: 100% !important;
							}
						}
					}

				}
			}
		}
	}
}
</style>
